import React, { memo, useState, useEffect } from "react";
import {
  Checkbox,
  Button,
  CircularProgress,
  TextField,
} from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import {
  selectTargetLabels,
  selectIsLoadingAutoLabel,
} from "redux/app/selectors";
import { autoLabelRequest } from "redux/app/actions";
import { getParameterByName, removeAccents } from "helpers";
import { func } from "prop-types";

const AutoLabel = ({ setOpen }) => {
  const dispatch = useDispatch();
  const sourceId = getParameterByName("sourceId");
  const targetLabels = useSelector(selectTargetLabels);
  const isLoading = useSelector(selectIsLoadingAutoLabel);

  const [selectedTargetLabels, setSelectedTargetLabels] = useState([]);
  const [searchText, setSearchText] = useState("");

  const filteredLabels = [...(targetLabels || [])]
    .filter((i) =>
      removeAccents(i.name.toLowerCase()).includes(
        removeAccents(searchText.toLowerCase())
      )
    )
    .sort((a, b) => a.name.localeCompare(b.name, "vi"));

  useEffect(() => {
    setSelectedTargetLabels(targetLabels || []);
  }, [targetLabels]);

  const handleChange = (i) => {
    setSelectedTargetLabels((prev) => {
      if (prev.some((o) => o.label_id === i.label_id)) {
        return prev.filter((item) => item.label_id !== i.label_id);
      } else {
        return [...prev, i];
      }
    });
  };

  const handleChangeAll = () => {
    const isAllVisibleSelected = filteredLabels.every((label) =>
      selectedTargetLabels.some((item) => item.label_id === label.label_id),
    );
    if (isAllVisibleSelected) {
      const visibleIds = filteredLabels.map((i) => i.label_id);
      setSelectedTargetLabels((prev) =>
        prev.filter((item) => !visibleIds.includes(item.label_id)),
      );
    } else {
      setSelectedTargetLabels((prev) => {
        const newSelected = [...prev];
        filteredLabels.forEach((label) => {
          if (!newSelected.some((item) => item.label_id === label.label_id)) {
            newSelected.push(label);
          }
        });
        return newSelected;
      });
    }
  };

  const handleAutoLabels = () => {
    const targetLabelIds = selectedTargetLabels.map((i) => i.label_id);

    dispatch(
      autoLabelRequest({
        data: {
          sourceId,
          targetLabelIds,
        },
        onSuccess: () => setOpen(false),
      }),
    );
  };
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <TextField
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        onKeyDown={(e) => e.stopPropagation()}
        placeholder="Tìm kiếm nhãn..."
        variant="outlined"
        size="small"
        fullWidth
        autoFocus
      />
      <div className="tw-text-xs tw-text-gray-500 tw-pt-1 tw-pb-2 tw-pl-1">
        {selectedTargetLabels.length} label(s) selected
      </div>
      <div>
        {filteredLabels.length > 0 && (
          <div className="tw-flex tw-items-center tw-gap-2">
            <Checkbox
              checked={
                filteredLabels.length > 0 &&
                filteredLabels.every((label) =>
                  selectedTargetLabels.some(
                    (item) => item.label_id === label.label_id,
                  ),
                )
              }
              onChange={handleChangeAll}
              size="small"
            />
            <span>Tất cả.</span>
          </div>
        )}
        <div style={{ maxHeight: "300px", overflow: "auto" }}>
          {filteredLabels.map((i) => (
            <div
              key={i.label_id}
              style={{ display: "flex", alignItems: "center", gap: 6 }}
            >
              <Checkbox
                checked={selectedTargetLabels.some(
                  (item) => item.label_id === i.label_id,
                )}
                onChange={() => handleChange(i)}
                size="small"
              />
              <span style={{ fontSize: "12px" }}>{i.name}.</span>
            </div>
          ))}
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          color="light"
          className="custom-btn-light mr-1"
          onClick={() => setOpen(false)}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={handleAutoLabels}
          disabled={selectedTargetLabels.length === 0 || isLoading}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 3 }}>
            Auto Labels
            {isLoading && <CircularProgress size={10} />}
          </div>
        </Button>
      </div>
    </div>
  );
};

export default memo(AutoLabel);

AutoLabel.propTypes = {
  setOpen: func,
};
